import * as types from './constants'
import {ErrorsFromApi} from '@myxplor/ui'
import {fetchWithRetry} from '../authorisation'

export const processResponse = (response) => ({
  type: types.AUTH_PERSONNEL_LOADED,
  attributes: response.attributes
})

export const assignAuthPerson = (id) => ({
  type: types.AUTH_PERSON_ASSSIGNED,
  person_id: id
})

const successful = () => ({
  type: types.AUTH_PERSON_SUBMITTED_SUCCESS,
  notification: {
    message: 'Authorised person saved'
  }
})

const failed = (response) => ({
  type: types.AUTH_PERSON_SUBMITTED_FAILED,
  errors: response.errors
})

const APIFailed = (message) => ({
  type: types.AUTH_PERSON_SUBMITTED_FAILED,
  errors: [],
  notification: {
    message: ErrorsFromApi(message),
    message_type: 'error'
  }
})

const processing = () => ({
  type: types.AUTH_PERSON_SUBMITTED_PENDING
})

export const submit = (params) => (dispatch) => {
  dispatch(processing())

  return fetchWithRetry(
    process.env.REACT_APP_API_HOST + '/api/services/authorisation',
    {
      token: params.tokens.jwt,
      method: 'PATCH',
      jsonAPI: true,
      body: {
        data: {
          type: 'personnel',
          ...(params.payload)
        }
      }
    },
    dispatch
  )
    .then(response => {
      return response.json().then(payload => {
        dispatch(response.ok ? 
          successful(payload) : 
          failed(payload)
        )
      })
    })
    .catch(response => {
      dispatch(
        APIFailed(response.message)
      )
    })
}


// WEBPACK FOOTER //
// ./src/auth-personnel/actions.js